// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.device

import org.multipaz.cbor.DataItem
import org.multipaz.device.AssertionNonce
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Bstr

fun AssertionNonce.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "zhMgsVgot5RDtRT1lkn0UA7tr04TBwsWpqC6AE9upS8")
val AssertionNonce_cborSchemaId = ByteString(-50, 19, 32, -79, 88, 40, -73, -108, 67, -75, 20, -11, -106, 73, -12, 80, 14, -19, -81, 78, 19, 7, 11, 22, -90, -96, -70, 0, 79, 110, -91, 47)

fun AssertionNonce.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "Nonce")
    builder.put("nonce", Bstr(this.nonce.toByteArray()))
    return builder.end().build()
}

fun AssertionNonce_fromDataItem(dataItem: DataItem): AssertionNonce {
    val nonce = ByteString(dataItem["nonce"].asBstr)
    return AssertionNonce(
        nonce = nonce,
    )
}
